import React from 'react';
import { token } from '@atlaskit/tokens';

const primaryColor = token('color.icon');

export const HelpCenterIcon = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M4.00001 8.01192C4.00001 6.53192 5.19068 5.33325 6.66001 5.33325H25.34C26.8093 5.33325 28 6.53592 28 8.01192V18.6546C28 20.1346 26.8093 21.3333 25.34 21.3333H6.66001C5.95227 21.3301 5.27471 21.0462 4.77602 20.5441C4.27732 20.0419 3.99824 19.3623 4.00001 18.6546V8.01192ZM6.66668 18.6666H25.3333V7.99992H6.66668V18.6666Z"
			fill={primaryColor}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.3333 22.6666H18.6667V26.6666H13.3333V22.6666ZM12 27.3333C12 27.1585 12.0686 26.9907 12.191 26.866C12.3134 26.7414 12.48 26.6697 12.6547 26.6666H19.3453C19.5201 26.6697 19.6866 26.7414 19.809 26.866C19.9314 26.9907 20 27.1585 20 27.3333V27.9999H12V27.3333Z"
			fill={primaryColor}
		/>
	</svg>
);
